/**
 * The Ulule authentication system has an "Impostor" feature that allows users with elevated privileges to log as any other user.
 * This is used to facilitate providing support for users by being able to see the app in the same way they would.
 * On the technical side, this is done through an `<impostor> as <target>` syntax, so we need to separate the `as` syntax from the raw input sometimes to adapt field validation.
 *
 * @param sourceEmail - The email string that may contain the "as" syntax for impersonation.
 * @returns An object containing the original email and a boolean indicating if it was an impostor login.
 */
export function getImpostorFreeEmail(sourceEmail: string) {
  const [email, impostorTarget] = sourceEmail.split(' as ')
  return {
    email,
    isImpostor: Boolean(impostorTarget),
  }
}
